/**
 * Created by Diana Aglyamutdinova 22.04.2019
 */

/**
 * @class start view of program container Layer
 * @extends pmui.NodeLayer
 * @constructor
 * @param {Number} [hideDuration=pmui.PopupLayer.STANDARD_HIDE_DURATION] Delay before self removing.
 */

pmui.RepeaterNode = pmui.NodeLayer.extend(/** @lends pmui.NodeLayer# */{
	_type: null,

	ctor: function (treeNode, parent, type)
	{
		var topSep = - 10;
		if(pmui.NodeLayer.KUMIR_MODE)
		{
			topSep = - pmui.BodyNode.FIRST_HEIGHT;
		}

		this.type = FunctionButton.Type.Repeater;
		this.isPartlyClonable = true;
		this._withBorder = true;
		this._super(parent, treeNode);

		this.setLayoutType(ccui.Layout.RELATIVE);

		this._type = type;
		var text = this.createText("cb", pmui.NodeLayer.CONSTR_COLOR);
		var end = this.createText("cend", pmui.NodeLayer.CONSTR_COLOR);

		this.createALignSome(text, "",  pmui.RepeaterNode.BEGIN_TAG, ccui.RelativeLayoutParameter.PARENT_TOP_LEFT, pmui.NodeLayer.SEPARATORX, pmui.NodeLayer.SEPARATORY *2, 0,0);
		this.createALignSome(end, pmui.RepeaterNode.BODY_TAG,  pmui.RepeaterNode.END_TAG, ccui.RelativeLayoutParameter.LOCATION_BELOW_LEFTALIGN,
			-ProgramContainerLayer.SEPARATOR_SIZEX, -pmui.NodeLayer.SEPARATORY, 0, 0);

		this.addChild(text);
		this.addChild(end);

	},

	updateIteratorVal: function () {}
});
pmui.RepeaterNode.BEGIN_TAG = "begin_cycle";
pmui.RepeaterNode.BODY_TAG = "cycle_body";
pmui.RepeaterNode.END_TAG = "end_cycle";
pmui.RepeaterNode.vals = [
	pm.LoopVals.for,
	pm.LoopVals.nTimes,
	pm.LoopVals.whileC
];

pmui.RepeaterNode.Constants = [
	pm.Constants.One,
	pm.Constants.Two,
	pm.Constants.Three,
	pm.Constants.Four,
	pm.Constants.Five,
	pm.Constants.Six
];
